import React, {Component} from 'react';
import {connect} from "react-redux";
import log from "../../util/log";
import PropTypes from 'prop-types';
import sapi from "../../util/sapi";
import _ from 'lodash';
import Button from '../partials/elements/Button';
import colors from "../../util/colors";
import {loadStripe} from '@stripe/stripe-js';
import {
  CardElement,
  Elements,
  ElementsConsumer,
  CardNumberElement,
  CardCvcElement,
  CardExpiryElement, } from '@stripe/react-stripe-js';
import Promise from "bluebird";
import ValidationErrors from "../partials/components/ValidationErrors";
import filters from "../../helpers/filters";
import { getErrorMessage, getMessageForError} from "../../util/errors";
import sharedActions from "../../actions/shared-actions";
import accountActions from "../../actions/account-actions";
import {BiCheck} from "react-icons/all";
import modalActions from "../../actions/modal-actions";
import utils from "../../util/util";
import api from "../../util/api";
import stripeHelper from "../../util/stripe-helper";
import Loading from "../partials/util/Loading";
import {withVFTranslation} from "../../util/withVFTranslation";
import moment from "moment";
import c from "../../util/const";
import {Carousel} from "react-responsive-carousel";
import ExpandableRow from "../partials/components/ExpandableRow";
import {Motion, spring} from '@serprex/react-motion';
import Slider from "react-slick";
import appActions from "../../actions/app-actions";
import vfLocalStorage from "../../util/local-storage";
import withVfRouting from "../../util/withVFRouting";

class UpgradeDialogNew extends Component {

  static YEARLY_TERM_SECONDS = (60 * 60 * 24 * 365);

  static MODES = {
    UPGRADE : 'upgrade',
    CLOSE_ACCOUNT : 'close_account'
  }

  _isMounted = false;

  CLOSE_ACCOUNT_CARD_ID = -1;
  NO_OPTIONS_CARD_ID = -2;

  STEPS = {
    SELECT_PLAN : 'select_plan',
    CONFIRM_PLAN : 'confirm_plan'
  }

  planRefs = [];

  constructor(props) {
    super(props);

    this.planScrollPanelWrapRef = React.createRef();
    this.sliderRef = React.createRef();
    this.planSlideDestinationRef = React.createRef();

    this.state = {
      loading : false,
      stripePromise : null,
      validationErr : [],

      //We cache a copy of your acctClassInfo when the window loads so that we can continue
      //to display things based on this old plan in the event that you change your subscription status.
      copyOfAcctClassInfoOnWindowLoad : false,

      hasSomeCardInput : false,
      paymentWasSuccessful : false,

      selectedPlanBounds : null,
      planScrollContainerBounds : null,
      destinationBounds : null,
      doneAnimatingCard : false,

      windowStep : this.STEPS.SELECT_PLAN,
      selectedPlanId : null,
      selectedUIPlan : null,
      carouselStart : 0,
      uiPlans : [],

      showMonthlyPlans : true,
      allAvailablePlans : null,
      monthlyPlans : null,
      yearlyPlans : null,
      classInfo : null,

      isHandlingSubmitButtonClick : false,

      waitForClassInfoToBeReady : false,

      isFetchingThings : true,
      limitMessage : null,

      downgradeInputVal: '',
      closeAccountInputVal: '',
      closeAccountPwd: '',

      promo_code: '',
      valid_code_deets: null,
    }
  }

  getDialogMode(){
    return this.props.dialogMode || UpgradeDialogNew.MODES.UPGRADE;
  }

  isCloseAccountMode(){
    return this.getDialogMode() === UpgradeDialogNew.MODES.CLOSE_ACCOUNT;
  }

  componentDidMount() {
    this._isMounted = true;
    if(this.props.onRef){
      this.props.onRef(this)
    }

    this.loadWindow();
  }

  componentWillUnmount() {
    this._isMounted = false;
    if(this.props.onRef){
      this.props.onRef(undefined)
    }
  }

  loadWindow(){
    let { t } = this.props;
    this.setState({isFetchingThings : true})
    this.loadNeededDataIntoState()
      .then(() => {
        return this.loadPlans();
      })
      .then(() => {

        this.setState({
          limitMessage : this.props.upgradeType ? this.getUpgradeMessage() : null,
          isFetchingThings : false
        }, () => {

          this.setState({uiPlans : this.buildUiPlans()})

          setTimeout(() => {
            if(this.isCloseAccountMode()){
              this.scrollToPlan(this.CLOSE_ACCOUNT_CARD_ID);
            }
            else{
              this.scrollToStartupPlan();
            }
          }, 500)
        })
      })
      .catch((err) => {
        log.log('error loading upgrade dlg', err);
        this.props.showAlert(t("Error loading Subscription"), getMessageForError(err, t), () => {
          this.closeModal(false);
        });
      })
  }

  scrollToStartupPlan(){
    let {
      accountInfo,
      accountClassInfo
    } = this.props;

    //Startup logic here, is if you're expired, let's select the NEXT plan for you
    //If you have a current plan, select your current.

    //This logic is also contained in Home.js.  We want some special selection handling
    //for certain configurations.
    let acctClassBasicFlag = !!_.get(accountClassInfo, 'class_info.basic_class_flag');
    let nextClassId = +_.get(accountClassInfo, 'class_info.next_class_id');
    let termCost = +_.get(accountClassInfo, 'class_info.term_cost');
    let showSpecialDowngradeFlow = (acctClassBasicFlag === false) && _.isNumber(nextClassId) && termCost === 0;

    if(accountInfo['expiry_ttl'] <= 0){
      let {
        showMonthlyPlans,
        monthlyPlans,
        yearlyPlans
      } = this.state;

      let currentPlan = this.getCurrentPlanId();
      let slideIndex = -1;
      let slideToPlan = null;
      let slideToPlanId = -1;
      if(showMonthlyPlans){
        slideIndex = _.findIndex(monthlyPlans, (p) => +p.class_id === +currentPlan);
        if(slideIndex + 1 < monthlyPlans.length){
          slideIndex++;
        }
        slideToPlan = monthlyPlans[slideIndex];
        slideToPlanId = +slideToPlan.class_id;
      }
      else{
        slideIndex = _.findIndex(yearlyPlans, (p) => +p.class_id === +currentPlan);
        if(slideIndex + 1 < yearlyPlans.length){
          slideIndex++;
        }
        slideToPlan = yearlyPlans[slideIndex];
        slideToPlanId = +slideToPlan.class_id;
      }
      this.scrollToPlan(slideToPlanId);

      if(showSpecialDowngradeFlow) {
        let uiPlan = _.find(this.state.uiPlans, (p) => +p.id === +slideToPlanId);
        if(uiPlan) {
          setTimeout(() => {
            this.selectPlan(slideToPlanId, uiPlan);
          }, 750); //carousel speed is 500, so add a little extra.
        }
      }
    }
    else{
      this.scrollToCurrentPlan();
    }
  }

  scrollToCurrentPlan(){
    this.scrollToPlan(this.getCurrentPlanId());
  }

  getCurrentPlanId(){
    let {
      selectedPlanId
    } = this.state;
    let {
      accountInfo
    } = this.props;

    return selectedPlanId || +accountInfo.class_id;
  }

  getCurrentInstId(){
    let {
      accountClassInfo
    } = this.props;
    let currentInstId = _.get(accountClassInfo, 'class_info.inst_id', null);
    if(currentInstId === c.BLANK_INST_ID){
      currentInstId = null;
    }
    return currentInstId;
  }

  loadNeededDataIntoState(){
    return new Promise((resolve, reject) => {

      let currentInstId = this.getCurrentInstId();
      Promise.all([
          sapi.Stripe.availablePlans(),
          api.ClassInfo.list(currentInstId),
          sapi.AccountInfo.quota(),
          this.props.updateUserHandle()
        ])
        .then(data => {
          let {
            accountClassInfo
          } = this.props;
          let termLength = _.get(accountClassInfo, 'class_info.term_length', 0);
          let startYearly = termLength === UpgradeDialogNew.YEARLY_TERM_SECONDS;

          let upgradePlans = data[0].data;
          this.setState({
            copyOfAcctClassInfoOnWindowLoad : {...accountClassInfo},
            showMonthlyPlans : !startYearly,
            upgradePlans : upgradePlans,
            classInfo : data[1].data,
            acctQuota : data[2].data,
            stripePromise : loadStripe(upgradePlans.pub_key)
          }, () => {
            resolve(true);
          })
        })
        .catch((err) => {
          reject(err);
        })
    })
  }

  loadPlans() {
    return new Promise((resolve, reject) => {
      let {
        classInfo
      } = this.state;
      let {
        accountClassInfo,
        stripeAvailables
      } = this.props;

      //certain inst-related payment plans come in via the current and upgrade blocks.
      //If these exist, and we don't have them in class_info, then we should fetch them explicitly
      //and put those in with the normal plans.

      //EXTRA!!!! walk through next_class_id - make sure this 'nextness' is accounted for when ordering
      let currentBlock = _.get(accountClassInfo, 'class_info', {});
      let upgradeBlock = _.get(stripeAvailables, 'class_info', {});

      log.log('classInfo about to load', currentBlock, upgradeBlock, classInfo);
      let classIdsToFetch = [];
      if (currentBlock && !_.isEmpty(currentBlock) && !_.find(classInfo, (info) => +info.class_id === +currentBlock.class_id)) {
        classIdsToFetch.push(currentBlock.class_id);
        if(currentBlock.next_class_id && !_.find(classInfo, (info) => +info.class_id === +currentBlock.next_class_id)){
          classIdsToFetch.push(currentBlock.next_class_id);
        }
      }
      if (upgradeBlock && !_.isEmpty(upgradeBlock) && !_.find(classInfo, (info) => +info.class_id === +upgradeBlock.class_id)) {
        classIdsToFetch.push(upgradeBlock.class_id);
        if(upgradeBlock.next_class_id && !_.find(classInfo, (info) => +info.class_id === +upgradeBlock.next_class_id)){
          classIdsToFetch.push(upgradeBlock.next_class_id);
        }
      }

      //This is needed because we add class_id and next_class_id above.  In some configurations
      //these can point to each other.
      classIdsToFetch = _.uniq(classIdsToFetch);

      //hey now.  don't be gettin too fancy
      Promise.all(_.map(classIdsToFetch, (class_id) => api.ClassInfo.get(class_id)))
        .then((res) => {
          log.log('classInfo loaded', classIdsToFetch, res);

          let availablePlans = [];
          _.each(classInfo, (info) => {
            availablePlans.push(info);
          })
          //Add to end of list.
          _.each(res, (r) => {
            let ci = _.get(r, 'data.class_info');
            if(ci) {
              availablePlans.push(ci);
            }
          })

          let unfilteredPlans = availablePlans;
          availablePlans = _.filter(availablePlans, (p) => this.shouldShowPlanForMode(p, availablePlans));

          let allAvailablePlans = _.sortBy(availablePlans, (p) => {
            //The goal is for all basic_class_flag classes to sort to the beginning
            //everything else sorts after these according to cost.
            if(_.isBoolean(p.basic_class_flag) && p.basic_class_flag){
              return -1;
            }
            else{
              return +p.term_cost;
            }
          });

          let monthlyPlans = [];
          let yearlyPlans = [];

          _.each(allAvailablePlans, (plan) => {
            let shouldListPlanInBothPlaces = (_.isBoolean(plan.basic_class_flag) && plan.basic_class_flag) || c.isFreeTier(+plan.class_id);

            //Find any plans with duplicate stripe_prod_id, but different class_id.
            let visibleDup = this.findDuplicatePlan(plan, allAvailablePlans);
            let productDup = this.findDuplicatePlan(plan, unfilteredPlans);

            let isAnnualTermPlan = plan['term_length'] === UpgradeDialogNew.YEARLY_TERM_SECONDS;

            plan._showNoMonthlyPlan = !productDup && isAnnualTermPlan;
            plan._showNoAnnualPlan = !productDup && !isAnnualTermPlan;

            if(visibleDup && !shouldListPlanInBothPlaces){
              log.log('dup right here', visibleDup, plan)
              if(isAnnualTermPlan){
                yearlyPlans.push(plan);
              }
              else{
                monthlyPlans.push(plan);
              }
            }
            else{
              monthlyPlans.push(plan);
              yearlyPlans.push(plan);
            }
          })

          log.log('loaded plans', monthlyPlans, yearlyPlans);
          this.setState({
            allAvailablePlans,
            monthlyPlans,
            yearlyPlans
          }, () => {
            resolve(availablePlans);
          })
        })
        .catch((err) => {
          log.log('error loading class infos', err);
          reject(err);
        })
    })
  }

  findDuplicatePlan(plan, plans){
    //Find any plans with duplicate stripe_prod_id, but different class_id
    return _.find(plans, (p) =>
      p.class_id !== plan.class_id &&
      p.stripe_prod_id &&
      p.stripe_prod_id === plan.stripe_prod_id
    );
  }

  getNormalizedMonthlyCost(plan){
    let termCost = +_.get(plan, 'term_cost', 0);
    if(+_.get(plan, 'term_length', 0) === UpgradeDialogNew.YEARLY_TERM_SECONDS){
      return termCost / 12;
    }
    return termCost;
  }

  shouldShowPlanForMode(plan){
    let {
      accountInfo,
      accountClassInfo
    } = this.props;

    //Always show your current plan.
    if(+plan.class_id === +accountInfo.class_id || _.get(plan, 'logo_tag') === _.get(accountClassInfo, 'class_info.logo_tag')){
      return true;
    }

    let currentMonthlyCost = this.getNormalizedMonthlyCost(_.get(accountClassInfo, 'class_info', {}));
    let planMonthlyCost = this.getNormalizedMonthlyCost(plan);

    if(this.isCloseAccountMode()){
      return planMonthlyCost <= currentMonthlyCost && this.planMeetsCurrentUsage(plan);
    }
    else{
      return planMonthlyCost > currentMonthlyCost && this.planMeetsCurrentUsage(plan);
    }
  }

  planMeetsCurrentUsage(plan){
    let {
      accountInfo,
      workspaces,
      contacts
    } = this.props;
    let {
      acctQuota
    } = this.state;

    //Always show your current plan.
    if(+plan.class_id === +accountInfo.class_id){
      return true;
    }

    let hostedWorkspaceCount = _.filter(workspaces, (ws) => !ws.host_uid).length;
    if(_.isNumber(plan.forum_max_total) && hostedWorkspaceCount > +plan.forum_max_total){
      return false;
    }

    let storageUsed = +_.get(accountInfo, 'quota.used', 0);
    if(_.isNumber(plan.max_storage) && storageUsed > +plan.max_storage){
      return false;
    }

    let contactCount = _.get(contacts, 'length', 0);
    if(_.isNumber(plan.max_contacts) && contactCount > +plan.max_contacts){
      return false;
    }

    let guestsUsed = +_.get(acctQuota, 'guests.used', 0);
    if(_.isNumber(plan.forum_max_guest) && guestsUsed > +plan.forum_max_guest){
      return false;
    }

    let docsUsed = +_.get(acctQuota, 'docs.used', 0);
    if(_.isNumber(plan.chat_max_doc) && docsUsed > +plan.chat_max_doc){
      return false;
    }

    if(this.props.userHandle && !_.get(plan, 'handle_flag', false)){
      return false;
    }

    return true;
  }

  getUpgradeMessage(){
    let { upgradeType, t } = this.props;

    if(upgradeType === UpgradeDialogNew.UPGRADE_TYPES.WORKSPACE){
      return t("You've reached your limit on Workspaces.  Upgrade now to increase your limits.")
    }
    else if(upgradeType === UpgradeDialogNew.UPGRADE_TYPES.DOCS){
      return t("You've reached your limit on Documents for this thread.  Upgrade now to increase your limits.")
    }
    else if(upgradeType === UpgradeDialogNew.UPGRADE_TYPES.STORAGE){
      return t("You've reached your limit on storage.  Upgrade now to increase your limits.")
    }
    else if(upgradeType === UpgradeDialogNew.UPGRADE_TYPES.SIGNING){
      return t("Your plan doesn't allow you to request signatures.  Upgrade now to enable signing.")
    }
    else if(upgradeType === UpgradeDialogNew.UPGRADE_TYPES.SIGNING_V1){
      return t("Your plan doesn't allow you to annotate Documents.  Upgrade now to enable Document annotation.")
    }
    else if(upgradeType === UpgradeDialogNew.UPGRADE_TYPES.MAX_V2_SIGNING_LIMIT){
      return t("You've used up your free signature requests.  Please upgrade to continue.")
    }
    else if(upgradeType === UpgradeDialogNew.UPGRADE_TYPES.MERCHANT_INVOICING){
      return t("Invoicing is not included with your plan. Please upgrade to continue.")
    }
  }

  closeModal(res) {
    let {close} = this.props;

    log.log('stripe checkout close modal', res);
    close(res);
  }

  updateAccountData() {
    return Promise.all([
      this.props.updateAccountInfo(true),
      this.props.updateStripeAvailables(),
      this.props.updateStripeData(),
      this.props.updateLogo()
    ])
  }

  pollAvailablePlansUntilReadyForSubscribing(){
    if(!this._isMounted){
      return;
    }

    this.setState({
      waitForClassInfoToBeReady : true
    })
    let pollAvailablePlans = () => {
      return new Promise((resolve, reject) => {
        sapi.Stripe.availablePlans()
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            resolve(err);
          })
      })
    }

    return pollAvailablePlans()
      .then((res) => {
        let upgradePlans = res;
        let classInfo = _.get(upgradePlans, 'class_info');
        if(!classInfo || _.isEmpty(classInfo)){
          return utils.waitFor(500)
            .then(() => {
              return this.pollAvailablePlansUntilReadyForSubscribing();
            })
        }
        else{
          this.setState({
            upgradePlans : res,
            waitForClassInfoToBeReady : false
          })
          return true;
        }
      })
  }

  cancelSubscription() {
    let {
      t
    } = this.props;

    this.setState({loading:true})
    sapi.Stripe.unsubscribe()
      .then((res) => {
        log.log('cancel res', res);
        return this.onSubscribeSuccess(res);
      })
      .then(() => {
        this.setState({
          loading:false,
          isHandlingSubmitButtonClick : false
        })
      })
      .catch((err) => {
        log.log('error canceling', err);
        this.setState({loading:false})
        this.props.showAlert(t("Error cancelling subscription"), getMessageForError(err, t));
      })
  }

  onSubscribeSuccess(res){
    log.log('subscribe success', res);
    return new Promise((resolve, reject) => {
      this.setState({
        paymentWasSuccessful : true
      }, () => {
        //Kind of weird looking!  We want to set a flag to show success, and show it for
        //at least 3 seconds.  Might as well do work while we're waiting, so let's
        //update account data in parallel to that wait by waiting for both promises here.
        //Then close the window.
        Promise.all([
          utils.waitFor(3000),
          this.updateAccountData()
        ])
          .finally(() => {
            this.closeModal(res);
            resolve(true);
          })
      })
    })
  }

  onSubscribeFailure(err){
    let { t } = this.props;
    log.log('subscribe error', err);

    this.props.showAlert(t("Error processing card"), stripeHelper.getMessageForStripeOrVfError(err, t));

    return this.updateAccountData()
      .then((res) => {

        //In payment failure cases, we need to refresh stripe/2/avail, and detect
        //The case where class_info has been nulled.  If it has, we need to wait for it to repopulate.
        //Until this time, the backend is not ready to subscribe.
        //This is really just a problem for stripe 3d auth failure cases.  In that case
        //we know about the failure before the backend does, which means we need to wait for it.
        //bug 2704
        let { upgradePlans } = this.state;
        let classInfo = _.get(upgradePlans, 'class_info');
        log.log('after update account data', upgradePlans, classInfo);
        if(!classInfo || _.isEmpty(classInfo)){
          log.log('doing polling thing')
          this.pollAvailablePlansUntilReadyForSubscribing();
        }
      })
  }

  onSuccessfulPaymentMethod(paymentMethodId, toClassId, couponId, stripe){
    log.log('onSuccessfulPaymentMethod', arguments);
    let { t } = this.props;

    sapi.Stripe.subscribeV2(paymentMethodId, toClassId, couponId)
      .then((res) => {
        log.log('subscribe res', res);
        return this.onSubscribeSuccess(res);
      })
      .then(() => {
        this.setState({
          loading:false,
          isHandlingSubmitButtonClick : false
        })
      })
      .catch((err) => {
        let stripeClientSecret = _.get(err, 'body.data.client_secret');
        if(err && err.name === 'APP_PARTIAL_FAIL' && stripeClientSecret){
          log.warn('got partial fail', err);
          stripeHelper.handleStripe3DAuth(stripe, stripeClientSecret, paymentMethodId, t)
            .then((res) => {
              //upgrade is finished as soon as 3d auth returns.
              return this.onSubscribeSuccess(res);
            })
            .catch((err) => {
              this.onSubscribeFailure(err);
            })
            .finally(() => {
              this.setState({
                loading:false,
                isHandlingSubmitButtonClick : false
              })
            })
        }
        else{
          this.setState({
            loading:false,
            isHandlingSubmitButtonClick : false
          })
          this.onSubscribeFailure(err);
        }
      })
  }

  onSubmitButtonClick(stripe, elements, evt){
    evt.preventDefault();

    let { t } = this.props;
    if(this.state.isHandlingSubmitButtonClick){
      log.log('prevent stripe submit');
      return;
    }

    if(this.state.waitForClassInfoToBeReady){
      this.props.showAlert(t("Just a moment"), t("Sorry, we're updating our records. Please wait a moment and try again."));
      return;
    }

    this.setState({isHandlingSubmitButtonClick : true});

    let { postal } = this.state;
    stripe.createPaymentMethod({
      type: 'card',

      //This is a weird parameter, and is NOT documented in the stripe docs.
      //You don't need to pass the rest of the card elements into the card.
      //You just give stripe the first element and it will apparently detect the rest.  Weird guys.
      //https://github.com/stripe/react-stripe-elements/issues/482
      // card: elements.getElement(CardNumberElement),
      card: elements.getElement(CardElement),

      //This is an expected stripe field
      //We could pass more if we wanted.
      //https://stripe.com/docs/js/payment_methods/create_payment_method
      // billing_details: {
      //   address: {
      //     postal_code: postal,
      //   },
      // },
    })
      .then((res) => {
        const {error, paymentMethod} = res;
        log.log('payment method res', error, paymentMethod);

        if(error && !_.isEmpty(error)){
          // code: "invalid_number"
          // message: "Your card number is invalid."
          // type: "validation_error"
          this.setState({
            validationErr : [error.message],
            isHandlingSubmitButtonClick : false
          })
        }
        else if(!paymentMethod || !paymentMethod.id){
          //I'm not sure this is a real case.  I guarded against it because the docs did.
          this.setState({
            validationErr : [getErrorMessage("APP_UNKNOWN_ERROR", t)],
            isHandlingSubmitButtonClick : false
          })
        }
        else{
          this.setState({
            validationErr : [],
            loading:true
          });
          let {valid_code_deets, selectedPlanId} = this.state;
          let couponId = _.get(valid_code_deets, 'coupon.id');
          this.onSuccessfulPaymentMethod(paymentMethod.id, selectedPlanId, couponId, stripe)
        }
      })

  }

  selectPlan(selectedPlanId, uiPlan){
    let scrollPanelBounds = this.getPlanScrollPanelBounds();
    let selectedPlanBounds = this.getSelectedPlanBounds(selectedPlanId);
    // log.log('select plan here', selectedPlanId, uiPlan, scrollPanelBounds, selectedPlanBounds);
    this.setState({
      selectedPlanId,
      selectedUIPlan : uiPlan,

      doneAnimatingCard : false,
      selectedPlanBounds : selectedPlanBounds,
      planScrollContainerBounds : scrollPanelBounds,
    }, () => {
      this.setState({
        windowStep : this.STEPS.CONFIRM_PLAN
      })
    })
  }

  getPlanScrollPanelBounds(){
    let ref = _.get(this.planScrollPanelWrapRef, 'current')
    if(ref){
      let bounds = ref.getBoundingClientRect();
      return bounds;
    }
  }

  getSelectedPlanBounds(id){
    let res = null;
    let found = _.find(this.planRefs, (obj) => id === obj.id);
    if(found){
      //log.log('found selected plan ref', found.ref, found.ref.current, found.ref.offsetLeft);
      res = found.ref.getBoundingClientRect();
    }
    return res;
  }

  getShowSubscriptionMayNotBeAvailableWarning(){
    let {
      selectedUIPlan,
      copyOfAcctClassInfoOnWindowLoad
    } = this.state;

    let currentPlanHasLegacyFlag = _.get(copyOfAcctClassInfoOnWindowLoad, 'class_info.legacy_flag');
    let currentPlanTermCost = +_.get(copyOfAcctClassInfoOnWindowLoad, 'class_info.term_cost', 0);
    let currentPlanTermLength = _.get(copyOfAcctClassInfoOnWindowLoad, 'class_info.term_length', 0);
    let currentPlanTermCostCents = currentPlanTermCost * 100;
    if(currentPlanTermLength === UpgradeDialogNew.YEARLY_TERM_SECONDS){
      currentPlanTermCostCents = currentPlanTermCostCents / 12;
    }
    return currentPlanHasLegacyFlag || selectedUIPlan.termCostCents <= currentPlanTermCostCents;
  }

  scrollToPlan(class_id){
    let slideIndex = _.findIndex(this.state.uiPlans, (p) => +p.id === +class_id);

    if(slideIndex >= 0 && this.sliderRef) {
      this.sliderRef.slickGoTo(slideIndex);
    }
  }

  onPlanRef(id, ref){
    let foundIndex = _.findIndex(this.planRefs, (plan) => plan && plan.id === id);
    if(foundIndex >= 0){
      this.planRefs[foundIndex] = {id, ref};
    }
    else{
      this.planRefs.push({
        id, ref
      })
    }
  }

  getPlanPointForMerchantLink(availablePlan){
    let { t } = this.props;
    let merchantFeeCents = availablePlan.merchant_fee_flat * 100;
    return {
      isMerchantLink : true,
      text : t("Request and Receive Payments for "),
      linkText : filters.getCurrency(this.props.i18n.language, merchantFeeCents) + t(" / transaction"),
      onLinkClick : (p) => {
        this.props.showAuthInfo(
          t('Verifyle Payment Requests'),
          <div>
            <div>
              <p>
                {t("Verifyle Black and Platinum users pay no transaction fee to Verifyle. All other Verifyle subscribers pay a small flat transaction fee depending on their plan. Additional external processing fees apply. Details are available at stripe.com/pricing.")}
              </p>
            </div>
          </div>
        )
      }
    }
  }

  buildUiPlans(){
    let {
      showMonthlyPlans,
      monthlyPlans,
      yearlyPlans
    } = this.state;
    let {
      t
    } = this.props;

    let availablePlans = showMonthlyPlans ? monthlyPlans : yearlyPlans;

    let plans = [];
    _.each(availablePlans, (availablePlan) => {
      let termCostCents = +(availablePlan['term_cost']) * 100;
      let termLengthDays = availablePlan['term_length'] / (60 * 60 * 24);

      //if we're yearly, force monthly display
      if(availablePlan['term_length'] === UpgradeDialogNew.YEARLY_TERM_SECONDS){
        termCostCents = termCostCents / 12;
        termLengthDays = 30;
      }

      let digitalSignatureLine = t("Unlimited Digital Signatures");
      if(_.isNumber(availablePlan['sign_req_max'])){
        digitalSignatureLine = t("Includes ") + availablePlan['sign_req_max'] + t(" Free Digital Signatures");
      }

      let showPortalPoint = _.get(availablePlan, 'handle_flag', false);
      let merchant_flag = _.get(availablePlan, 'merchant_flag', false);

      //We allow decimal points in pricing now, but we only want display fractional amounts if needed.
      let showDecimalPoint = termCostCents % 100 !== 0;

      if(c.isFreeTier(availablePlan.class_id)){
        let points = [
          filters.getFileSizeString(t, +availablePlan['max_storage']) + t(" of Encrypted Storage"),
          t("Share Large Files"),
          t("Host up to ") + availablePlan['forum_max_total'] + t(" Workspaces"),
          t("Up to ") + availablePlan['max_contacts'] + t(" Contacts"),
          t("Up to ") + availablePlan['forum_max_guest'] + t(" Guests per Workspace"),
          t("Up to ") + availablePlan['chat_max_doc'] + t(" Documents per Workspace Thread"),
          digitalSignatureLine
        ]

        if(merchant_flag){
          points.push(this.getPlanPointForMerchantLink(availablePlan));
        }

        plans.push({
          id : +availablePlan.class_id,
          title : availablePlan.label,
          termCostCents,
          termCost : filters.getCurrency(this.props.i18n.language, termCostCents, !showDecimalPoint),
          term : t('forever'),
          points
        })
      }
      else{
        let isVFBlack = _.get(availablePlan, 'logo_tag') === c.ACCOUNT_LOGO_TYPES.BLACK;
        let points = [];
        if(!isVFBlack){
          points = [
            filters.getFileSizeString(t, +availablePlan['max_storage']) + t(" of Encrypted Storage"),
            t("Share Large Files"),
            t("Host up to ") + availablePlan['forum_max_total'] + t(" Workspaces"),
            t("Up to ") + availablePlan['max_contacts'] + t(" Contacts"),
            t("Up to ") + availablePlan['forum_max_guest'] + t(" Guests per Workspace"),
            t("Up to ") + availablePlan['chat_max_doc'] + t(" Documents per Workspace Thread"),
            digitalSignatureLine,
            t("Unlimited SMS Signer Verification"),
            t("Unlimited PDF Editing"),
            t("Display Your Logo")
          ]
        }
        else{
          points = [
            t("Unlimited Encrypted Storage"),
            t("Share Large Files"),
            t("Unlimited Workspaces"),
            t("Up to ") + availablePlan['max_contacts'] + t(" Contacts"),
            t("Up to ") + availablePlan['forum_max_guest'] + t(" Guests per Workspace"),
            t("Up to ") + availablePlan['chat_max_doc'] + t(" Documents per Workspace Thread"),
            digitalSignatureLine,
            t("Unlimited SMS Signer Verification"),
            t("Unlimited PDF Editing"),
            t("Display Your Logo")
          ]
        }

        if(showPortalPoint){
          points.push(t("Custom Public Upload Page"))
        }

        if(isVFBlack){
          points.push(t("Extended Renewal Protection"))
          points.push(t("Priority Access to New Features"))
        }

        if(merchant_flag){
          points.push(this.getPlanPointForMerchantLink(availablePlan));
        }

        if(availablePlan._showNoMonthlyPlan){
          //if no plan is available monthly, show yearly term info
          //Sort of weird, we convert this earlier, now we're converting it back.
          termCostCents = +(availablePlan['term_cost']) * 100;
          termLengthDays = availablePlan['term_length'] / (60 * 60 * 24);
          showDecimalPoint = false;
        }

        plans.push({
          id : +availablePlan.class_id,
          title : availablePlan.label,
          termCostCents,
          showNoAnnualPlanWarning : availablePlan._showNoAnnualPlan,
          showNoMonthlyPlanWarning : availablePlan._showNoMonthlyPlan,
          termCost : filters.getCurrency(this.props.i18n.language, termCostCents, !showDecimalPoint),
          term : filters.getFriendlyTermLength(t, termLengthDays),
          points
        })
      }
    })

    if(this.isCloseAccountMode()){
      let hasCheaperOptions = _.some(plans, (p) => p.id !== +_.get(this.props.accountInfo, 'class_id'));
      if(!hasCheaperOptions){
        plans.unshift({
          id : this.NO_OPTIONS_CARD_ID,
          isNoOptionsCard : true
        })
      }
      plans.push({
        id : this.CLOSE_ACCOUNT_CARD_ID,
        isCloseCard : true
      })
    }

    return plans;
  }

  renderPlanPanel(){
    let {
      isFetchingThings,
      uiPlans
    } = this.state;

    if(isFetchingThings){
      return (
        <div className="pb-3">
          <div className="row">
            <div className="col">
              <Loading className={'m-5'} centered={true} size={'sm'}/>
            </div>
          </div>
        </div>
      )
    }
    return this.renderCarousel(uiPlans);
  }

  renderCarousel(plans){
    const buttonWrapStyle = {
      position: 'absolute',
      top: '40%',
      zIndex: 1
    }

    const buttonStyle = {
      height: '90px',
      width: '90px',
      borderRadius: '50%'
    }

    const iconStyle = {
      fontSize: '60px',
      lineHeight: 'normal'
    }

    const RenderPrevButton = (props) => {
      const { className, style, onClick } = props;

      let isDisabled = (className || "").indexOf("slick-disabled") >= 0;
      return (
        <div style={{...style, ...buttonWrapStyle, ...{left: '10px'}}} >
          <button onClick={onClick}
                  style={buttonStyle}
                  disabled={isDisabled}
                  className={"btn btn-icon btn-primary vf-upgrade-panel-btn"}>
            <i style={{...iconStyle, ...{paddingRight: '5px'}}} className="icon ion-chevron-left" />
          </button>
        </div>
      )
    }

    const RenderNextButton = (props) => {
      const { className, style, onClick } = props;
      let isDisabled = (className || "").indexOf("slick-disabled") >= 0;
      return (
        <div style={{...style,...buttonWrapStyle, ...{right: '10px'}}} >
          <button onClick={onClick}
                  style={buttonStyle}
                  disabled={isDisabled}
                  className={"btn btn-icon light-color btn-primary vf-upgrade-panel-btn"}>
            <i style={{...iconStyle, ...{}}} className="icon ion-chevron-right" />
          </button>
        </div>
      );
    }

    let carouselSettings = {
      initialSlide: this.state.carouselStart || 0,
      className: "center",
      centerMode: true,
      infinite: false,
      centerPadding: "60px",
      dots: true,
      variableWidth: true,
      speed: 500,
      nextArrow:  <RenderNextButton />,
      prevArrow: <RenderPrevButton />,
      responsive: [
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    }

    return (
      <div className="pb-3">
        <div className={`slider-container ${plans.length === 1 ? 'single-slide' : ''}`} ref={this.planScrollPanelWrapRef}>
          <Slider {...carouselSettings}
                  key={this.state.carouselKey || 0}
                  ref={slider => this.sliderRef = slider}>
            {_.map(plans, (plan) => {
              return (
                <div key={plan.id} ref={(ref) => this.onPlanRef(plan.id, ref)}>
                  {this.renderPlan(plan)}
                </div>
              )
            })}
          </Slider>
        </div>
      </div>
    )
  }

  renderPaymentCard(){
    let {
      selectedUIPlan,
    } = this.state;
    let {
      t
    } = this.props;

    let showMessageAboutSubscriptionsChangingWithTime = this.getShowSubscriptionMayNotBeAvailableWarning();

    return (
      <div className="card d-inline-block mx-1"
           style={{
             width: '23rem',
             height: PLAN_CARD_HEIGHT,
             borderRadius: '8px',
           }}>
        <div>
          <div className="text-center light-bg"
               style={{
                 borderTopLeftRadius: '8px',
                 borderTopRightRadius: '8px'
               }}>
            <h3 className="black-color py-3">
              {selectedUIPlan.termCostCents > 0 ? t("Payment Method") : ''}
            </h3>
          </div>

          {selectedUIPlan.termCostCents > 0 &&
          <div>
            <div className="mx-2" style={{marginTop: '46px'}}>
              {this.renderPaymentPanel()}
            </div>

            <div className="mx-2 mt-5">
              {this.renderPromoCodePanel()}
            </div>
          </div>
          }
          {selectedUIPlan.termCostCents === 0 &&
          <div>
            <div className="mx-2" style={{marginTop: '46px'}}>
              {this.renderFreePaymentPanel()}
            </div>
          </div>
          }
          <div>
            <div className="mx-2 hint-text" style={{marginTop: '46px'}}>
              {showMessageAboutSubscriptionsChangingWithTime &&
              <span>
                {t("Please note that the subscriptions we offer may change at any time. If you choose a new subscription, you may not be able to return to your previous subscription if you change your mind.")}
              </span>
              }
              <span>
                {` ${t("Click")} `}
                <a target={'_blank'}
                   className="underline"
                   href={c.links.tos}>{t("here")}</a>
                {` ${t("to review our pricing policies.")}`}
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  }

  leaveConfirmPanel(){
    this.setState({
      windowStep: this.STEPS.SELECT_PLAN,
      selectedPlanId: null,
      selectedUIPlan : null,

      closeAccountInputVal: '',
      closeAccountPwd: '',

      validationErr : [],
      promo_code: '',
      valid_code_deets: null,

      selectedPlanBounds : null,
      planScrollContainerBounds : null,
      doneAnimatingCard : false,
      destinationBounds : null,
    }, () => {
      setTimeout(() => {
        if(this.isCloseAccountMode()){
          this.scrollToPlan(this.CLOSE_ACCOUNT_CARD_ID);
        }
        else{
          this.scrollToCurrentPlan();
        }
      }, 500)
    })
  }

  renderConfirmPanel(){
    let {
      t
    } = this.props;
    let {
      selectedUIPlan,

      selectedPlanBounds,
      planScrollContainerBounds,
      doneAnimatingCard,

      destinationBounds
    } = this.state;

    //This is a little complicated in here due to the animations.
    //When you select a plan, we get the plan card's bounding rectangle, as well as the scroll panel bounding rectangle.
    //I show an invisible placeholder for the plan card destination because the destination layout is flex and I don't know the exact position.
    //I show that invisible placeholder in flex, and pull it's coords once it's rendered.  This affects layout of the payment card too.
    //Once we have all those pieces, I transition a new card from where it was in the list, to where it should be
    //over the top of the invisible placeholder card, and fade in the payment card.

    let cardSpacing = 15; //px padding between cards, not accounted for with client rect.
    let leftRightPanelMargin = 0; //If you add window margins, account for it here.  We don't have it anymore but used to.
    let startX = selectedPlanBounds.left - planScrollContainerBounds.left;
    let endX = destinationBounds ? (destinationBounds.left - planScrollContainerBounds.left - cardSpacing + leftRightPanelMargin) : 0;

    //This weird padding here is to replicate the amount of space that the slick carousel dots take up,
    //so that the window does not resize.  There's probably a better solution but some of the layout here is tricky.
    return (
      <div style={{paddingBottom: '16px'}}>
        <div className="d-flex justify-content-center position-relative">

          {destinationBounds && !doneAnimatingCard &&
          <Motion onRest={() => this.setState({doneAnimatingCard : true})}
                  defaultStyle={{left: startX}}
                  style={{left: spring(endX, {stiffness: 150, damping: 15})}}>
            {interpolatingStyle => {
              return (
                <div style={{
                  ...interpolatingStyle,
                  ...{
                    position: 'absolute',
                    top: 0,
                    zIndex: 1000
                  }
                }}>
                  {this.renderPlan(selectedUIPlan, true)}
                </div>
              )
            }}
          </Motion>
          }

          {doneAnimatingCard &&
          <div style={{
            height: selectedPlanBounds.height,
            width: selectedPlanBounds.width
          }}>
            {this.renderPlan(selectedUIPlan, true)}
          </div>
          }
          {!doneAnimatingCard &&
          <div ref={(ref) => {
            if (ref && !this.state.destinationBounds) {
              this.setState({
                destinationBounds: ref.getBoundingClientRect()
              })
            }
          }} style={{
            height: selectedPlanBounds.height,
            width: selectedPlanBounds.width
          }}/>
          }

          <Motion defaultStyle={{opacity: -1}} style={{opacity: spring(1)}}>
            {interpolatingStyle => {
              return (
                <div style={interpolatingStyle}>
                  {selectedUIPlan.isCloseCard ? this.renderCloseAccountPanel() : this.renderPaymentCard()}
                </div>
              )
            }}
          </Motion>
        </div>
      </div>
    )
  }

  renderPlan(plan, isConfirmView){
    let {
      selectedPlanId,
      paymentWasSuccessful,
      loading
    } = this.state;
    let {
      accountInfo,
      t
    } = this.props;

    if(plan.isCloseCard){
      return this.renderCloseAccountIntroCard(plan, isConfirmView);
    }
    if(plan.isNoOptionsCard){
      return this.renderNoOptionsCard();
    }

    let isCurrentPlan = plan.id === +_.get(accountInfo, 'class_id');

    return (
      <>
        <div className={`card d-inline-block mx-1 corp-light-grey-bg upgrade-plan-panel`}
             onClick={() => isConfirmView ? _.noop : this.scrollToPlan(plan.id)}
             style={{
               width: '23rem',
               height: PLAN_CARD_HEIGHT,
               borderRadius: '8px',
               color: colors.PRIMARY,
               textAlign: 'center'
             }}>
          <div>
            <div className="text-center light-bg"
                 style={{
                   borderTopLeftRadius: '8px',
                   borderTopRightRadius: '8px'
                 }}>
              <h3 className="black-color py-3">
                {plan.title}
              </h3>
            </div>
            <div>
              <div className="text-center pt-2">
                {plan.termCostCents === 0 &&
                <h2 className="text-uppercase mb-0">
                  {t("Free")}
                </h2>
                }
                {plan.termCostCents > 0 &&
                <h2 className="mb-0">
                  {plan.termCost}
                  <span className="small ps-2">
                    /{plan.term}
                  </span>
                </h2>
                }
                {plan.showNoAnnualPlanWarning &&
                  <div className="secondary-text-color" style={{lineHeight: '24px'}}>
                    {t("Annual Billing Unavailable")}
                  </div>
                }
                {plan.showNoMonthlyPlanWarning &&
                  <div className="secondary-text-color" style={{lineHeight: '24px'}}>
                    {t("Monthly Billing Unavailable")}
                  </div>
                }
                {!plan.showNoAnnualPlanWarning && !plan.showNoMonthlyPlanWarning &&
                  <div className="secondary-text-color" style={{minHeight: '24px'}}/>
                }
              </div>

              {isConfirmView &&
              <div className="text-center py-2 mx-2">
                <button className={`btn w-100 btn-primary`}
                        type="button"
                        disabled={paymentWasSuccessful || loading}
                        onClick={() => this.leaveConfirmPanel()}>
                  <i className={'ion-chevron-left me-2'}/>
                  {t("Back to Plan Options")}
                </button>
              </div>
              }
              {!isConfirmView &&
              <div className="text-center py-2 mx-2">
                <button className={`btn w-100 ${isCurrentPlan ? 'btn-outline-primary' : 'btn-primary'}`}
                        type="button"
                        onClick={() => this.selectPlan(plan.id, plan)}
                        disabled={isCurrentPlan}>
                  {isCurrentPlan && <i className={'ion-checkmark-circled me-2'}/> }
                  <span>{isCurrentPlan ? t("Current Plan") : t("Select Plan")}</span>
                </button>
              </div>
              }

              <div className="text-start px-2" style={{height: '13rem', marginLeft: '40px'}}>
                <ul className="list-group list-group-flush black-color my-1"
                    style={{
                      fontSize: '14px'
                    }}>
                  {_.map(plan.points, (p) => {

                    let pointContents = p;
                    if(p.isMerchantLink){
                      pointContents = <span>
                        {p.text}
                        <a className="primary-color has-pointer" onClick={() => p.onLinkClick(p)}>
                          {p.linkText}
                        </a>
                      </span>
                    }

                    return (
                      <li key={p.isMerchantLink ? p.linkText : p}
                          style={{
                            paddingTop: '13px',
                            paddingBottom: '13px',
                            lineHeight: '14px',
                            listStyle: 'disc'
                          }}>
                        {pointContents}
                      </li>
                    )
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  renderPayButton(){
    let {
      valid_code_deets,
      allAvailablePlans,
      selectedPlanId,
      loading,
      isHandlingSubmitButtonClick,
      paymentWasSuccessful,
      hasSomeCardInput
    } = this.state;
    let { t } = this.props;

    if(paymentWasSuccessful){
      return (
        <button className={`btn w-100 btn-success`}
                onClick={_.noop}
                disabled={true}
                type="button">
          <i className="icon ion-checkmark-circled light-color me-2" />
          {t("Success!")}
        </button>
      )
    }
    else if(loading){
      return (
        <button className={`btn w-100 btn-primary`}
                disabled={true}
                type="submit">
          <Loading centered={true}
                   color="light"
                   size={'sm'}/>
        </button>
      )
    }
    else{
      let selectedPlan = _.find(allAvailablePlans, (plan) => +plan.class_id === selectedPlanId)
      let termCostCents = 0;
      if(selectedPlan){
        termCostCents = +(selectedPlan['term_cost']) * 100;
      }
      if(valid_code_deets){
        termCostCents = valid_code_deets.price * 100;
      }

      return (
        <button className={`btn w-100 btn-primary`}
                disabled={isHandlingSubmitButtonClick || loading || !selectedPlanId || !hasSomeCardInput}
                type="submit">
          {t("Pay")} {filters.getDisplayCurrency(this.props.i18n.language, termCostCents)}
        </button>
      )
    }
  }

  doFreePlanValidation(){
    let { t } = this.props;
    let {
      downgradeInputVal
    } = this.state;
    let err = [];

    let formatted = _.trim(downgradeInputVal.toLowerCase());
    if(formatted.length === 0 || formatted !== t("downgrade")){
      err.push(t("Please type \'DOWNGRADE\'"));
    }

    this.setState({validationErr:err})
    return err.length === 0;
  }

  confirmFreePlanClick(){
    if(!this.doFreePlanValidation()){
      return;
    }

    this.cancelSubscription();
  }

  renderFreePayButton(){
    let {
      selectedPlanId,
      loading,
      isHandlingSubmitButtonClick,
      paymentWasSuccessful
    } = this.state;
    let { t } = this.props;

    if(paymentWasSuccessful){
      return (
        <button className={`btn w-100 btn-success`}
                onClick={_.noop}
                disabled={true}
                type="button">
          <i className="icon ion-checkmark-circled light-color me-2" />
          {t("Success!")}
        </button>
      )
    }
    else if(loading){
      return (
        <button className={`btn w-100 btn-primary`}
                disabled={true}
                type="submit">
          <Loading centered={true}
                   color="light"
                   size={'sm'}/>
        </button>
      )
    }
    else{
      return (
        <button className={`btn w-100 btn-primary`}
                type="button"
                onClick={this.confirmFreePlanClick.bind(this)}
                disabled={isHandlingSubmitButtonClick || loading || !selectedPlanId}>
          {t("Confirm")}
        </button>
      )
    }
  }

  onCardChange(evt){
    this.setState({
      hasSomeCardInput : !_.get(evt, 'empty', true),
      validationErr: []
    })
  }

  renderPaymentPanel(){
    let {
      paymentWasSuccessful,
      loading
    } = this.state;
    let { t } = this.props;

    return (
      <div className="container">
        <div className="row">
          <div className="col p-0">

            <div className="form-group">
              <label className="form-label fw-bold w-100 text-start dark-color">{t("Credit Card Information")}</label>
              <CardElement onChange={(evt) => this.onCardChange(evt)}
                           className="form-control"
                           options={{
                             disabled: (paymentWasSuccessful || loading),
                             iconStyle: 'solid',
                             style: {
                               base: {
                                 fontSize: '16px',
                                 lineHeight: '1.5',
                                 color: colors.DARK,
                                 '::placeholder': {
                                   color: colors.SECONDARY_TEXT,
                                 },
                               },
                               invalid: {
                                 color: colors.ASSERTIVE,
                               },
                             },
                           }}/>
            </div>

            <div className="text-center my-2">
              {this.renderPayButton()}
            </div>

            {this.state.validationErr.length > 0 &&
            <div className="my-2">
              <ValidationErrors errors={this.state.validationErr}/>
            </div>
            }

          </div>
        </div>
      </div>
    )
  }

  renderFreePaymentPanel(){
    let { t } = this.props;
    let {
      downgradeInputVal
    } = this.state;
    return (
      <div className="container">
        <div className="row">
          <div className="col p-0">

            <h4 className="text-uppercase text-center text-danger my-2">
              {t("Warning:")}
            </h4>
            <p className="text-center mb-4">
              {t("Downgrading your Verifyle account to Verifyle Basic will mean your account will be limited in storage, features and functionality, which may have an impact on your Contacts’ ability to access information you’ve previously shared with them as well as their ability to share information with you.")}
            </p>
            <p className="text-center mb-2">
              {t("To confirm you’d like to downgrade your Verifyle account, please type DOWNGRADE in the field below, and then click the blue “Confirm” button.")}
            </p>
            <div className="form-group">
              <input className={'form-control text-uppercase'}
                     type={'text'}
                     value={downgradeInputVal}
                     onKeyDown={(e) => {
                       //need to catch this and cancel so that the form doesn't submit.
                       if (e.key === 'Enter') {
                         e.preventDefault();
                         this.confirmFreePlanClick();
                       }
                     }}
                     onChange={(evt) => this.setState({downgradeInputVal: evt.target.value})}
                     placeholder={t("Downgrade")}/>
            </div>
            <div className="text-center mt-3">
              {this.renderFreePayButton()}
            </div>

            {this.state.validationErr.length > 0 &&
            <div className="my-2">
              <ValidationErrors errors={this.state.validationErr}/>
            </div>
            }

          </div>
        </div>
      </div>
    )
  }

  doCloseAccountValidation(){
    let { t } = this.props;
    let {
      closeAccountInputVal,
      closeAccountPwd
    } = this.state;
    let err = [];

    let formatted = _.trim(closeAccountInputVal.toLowerCase());
    if(formatted.length === 0 || formatted !== t("permanently delete")){
      err.push(t("Please type \'PERMANENTLY DELETE\'"));
    }

    if(!closeAccountPwd || closeAccountPwd.length === 0){
      err.push(t("Please enter your password"));
    }

    this.setState({validationErr:err})
    return err.length === 0;
  }

  confirmCloseAccountClick(){
    let { t } = this.props;
    if(!this.doCloseAccountValidation()){
      return;
    }

    this.setState({loading: true});
    sapi.AccountDelete.deleteAccount(this.state.closeAccountPwd)
      .then((res) => {
        log.log('account delete res', res);

        vfLocalStorage.clear();
        this.props.cleanup();
        setTimeout(() => {
          this.closeModal();
          this.props.router.navigate('/');
        }, 200);
      })
      .catch((err) => {
        log.log('error deleting account', err);
        this.setState({
          loading: false,
          validationErr : [ getMessageForError(err, t) ]
        })
      })
  }

  renderCloseAccountButton(){
    let {
      loading
    } = this.state;
    let { t } = this.props;

    return (
      <button className={`btn w-100 btn-danger`}
              type="button"
              onClick={this.confirmCloseAccountClick.bind(this)}
              disabled={loading}>
        {t("Close and Delete Account")}
      </button>
    )
  }

  scrollToOtherOptions(){
    let { uiPlans } = this.state;
    let first = _.find(uiPlans, (p) => !p.isCloseCard);
    if(first){
      this.scrollToPlan(first.id);
    }
  }

  renderNoOptionsCard(){
    let { t } = this.props;
    return (
      <div className="card d-inline-block mx-1"
           onClick={() => this.scrollToPlan(this.NO_OPTIONS_CARD_ID)}
           style={{
             width: '23rem',
             height: PLAN_CARD_HEIGHT,
             borderRadius: '8px',
             textAlign: 'center'
           }}>
        <div>
          <div className="text-center light-bg"
               style={{
                 borderTopLeftRadius: '8px',
                 borderTopRightRadius: '8px'
               }}>
            <h3 className="black-color py-3">
              {t("Other Options")}
            </h3>
          </div>

          <div className="mx-3 mt-4">
            <div className="corp-light-grey-bg p-3 text-start" style={{borderRadius: '8px'}}>
              <p className="black-color mb-2">
                {t("Your account already exceeds the limits of our lower tier plans, and is not currently eligible for a downgrade.")}
              </p>
              <p className="black-color mb-0">
                {t("You may be able to become eligible by reducing your Workspaces, Contacts or Documents.")}
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderCloseAccountIntroCard(plan, isConfirmView){
    let { t } = this.props;
    return (
      <div className="card d-inline-block mx-1"
           onClick={() => isConfirmView ? _.noop : this.scrollToPlan(this.CLOSE_ACCOUNT_CARD_ID)}
           style={{
             width: '23rem',
             height: PLAN_CARD_HEIGHT,
             borderRadius: '8px',
             textAlign: 'center'
           }}>
        <div>
          <div className="text-center light-bg"
               style={{
                 borderTopLeftRadius: '8px',
                 borderTopRightRadius: '8px'
               }}>
            {!isConfirmView &&
            <h3 className="black-color py-3">
              {t("Close Account")}
            </h3>
            }
            {isConfirmView &&
            <h3 className="black-color py-3">
              &nbsp;
            </h3>
            }
          </div>

          {/* A little extra work here to match button position in renderPlan */}
          <div>
            <div className="text-center pt-2 position-relative">
              <h2 className="mb-0" style={{visibility: 'hidden'}}>&nbsp;</h2>
              <div style={{minHeight: '24px'}}/>
              <div className="position-absolute d-flex align-items-center justify-content-center px-3"
                   style={{top: 0, left: 0, right: 0, bottom: 0}}>
                <p className="black-color mb-0" style={{lineHeight: '20px'}}>
                  {t("Before you go, see if we have a different subscription that better suits your needs.")}
                </p>
              </div>
            </div>

            <div className="text-center py-2 mx-2">
              {isConfirmView &&
              <button className="btn btn-primary w-100"
                      type="button"
                      disabled={this.state.loading}
                      onClick={() => this.leaveConfirmPanel()}>
                <i className={'ion-chevron-left me-2'}/>
                {t("Back")}
              </button>
              }
              {!isConfirmView &&
              <button className="btn btn-primary w-100"
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.scrollToOtherOptions();
                      }}>
                <i className={'ion-chevron-left me-2'}/>
                {t("View Other Subscriptions")}
              </button>
              }
            </div>

            {!isConfirmView &&
            <div className="mx-3 mt-4">
              <p className="mb-3">
                {t("If you still want to close your account, click below.")}
              </p>
              <button className="btn btn-outline-danger w-100"
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.selectPlan(this.CLOSE_ACCOUNT_CARD_ID, plan);
                      }}>
                {t("Close My Account")}
              </button>
            </div>
            }
          </div>
        </div>
      </div>
    )
  }

  renderCloseAccountPanel(){
    let { t } = this.props;
    let {
      closeAccountInputVal
    } = this.state;
    return (
      <div className="card d-inline-block mx-1"
           style={{
             width: '23rem',
             height: PLAN_CARD_HEIGHT,
             borderRadius: '8px',
             textAlign: 'center',
             overflow: 'auto'
           }}>
        <div>
          <div className="text-center light-bg"
               style={{
                 borderTopLeftRadius: '8px',
                 borderTopRightRadius: '8px'
               }}>
            <h3 className="black-color py-3">
              {t("Close Account")}
            </h3>
          </div>

          <div className="mx-3 mt-4">
            <p className="mb-4" style={{fontSize: '18px'}}>
              <span className="text-danger text-uppercase fw-bold">{t("Warning: ")}</span>
              {t("Are you sure you want to close your account?")}
            </p>

            <div className="corp-light-grey-bg text-start p-3 mb-4" style={{borderRadius: '8px'}}>
              <div className="fw-bold black-color pb-2 mb-2"
                   style={{borderBottom: `2px solid ${colors.PRIMARY}`}}>
                {t("What closing means:")}
              </div>
              <ul className="black-color mb-0 ps-3" style={{fontSize: '14px', lineHeight: '24px'}}>
                <li>{t("Your account will be immediately deleted")}</li>
                <li>{t("You'll no longer be charged")}</li>
                <li>{t("Deletion is permanent")}</li>
              </ul>
            </div>

            <p className="text-start mb-2">
              {t("To confirm, type PERMANENTLY DELETE and enter your password in the fields below, then click \"Close and Delete Account.\"")}
            </p>
            <div className="form-group">
              <input className={'form-control text-uppercase'}
                     type={'text'}
                     autoComplete="off"
                     autoCorrect="off"
                     spellCheck="false"
                     value={closeAccountInputVal}
                     onKeyDown={(e) => {
                       //need to catch this and cancel so that the form doesn't submit.
                       if (e.key === 'Enter') {
                         e.preventDefault();
                         this.confirmCloseAccountClick();
                       }
                     }}
                     onChange={(evt) => this.setState({closeAccountInputVal: evt.target.value})}
                     placeholder={t("Permanently Delete")}/>
            </div>
            <div className="form-group mt-2">
              <input className={'form-control'}
                     type={'password'}
                     autoComplete="off"
                     autoCorrect="off"
                     spellCheck="false"
                     value={this.state.closeAccountPwd}
                     onKeyDown={(e) => {
                       //need to catch this and cancel so that the form doesn't submit.
                       if (e.key === 'Enter') {
                         e.preventDefault();
                         this.confirmCloseAccountClick();
                       }
                     }}
                     onChange={(evt) => this.setState({closeAccountPwd: evt.target.value})}
                     placeholder={t("Password")}/>
            </div>
            <div className="text-center mt-3">
              {this.renderCloseAccountButton()}
            </div>

            {this.state.validationErr.length > 0 &&
            <div className="my-2">
              <ValidationErrors errors={this.state.validationErr}/>
            </div>
            }

            <div className="hint-text text-start mt-4">
              <span>
                {t("Please note that the subscriptions we offer may change at any time. If you choose a new subscription, you may not be able to return to your previous subscription if you change your mind.")}
              </span>
              <span>
                {` ${t("Click")} `}
                <a target={'_blank'}
                   className="underline"
                   href={c.links.tos}>{t("here")}</a>
                {` ${t("to review our pricing policies.")}`}
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  }

  validateCouponData(data) {
    let { t } = this.props;
    if (!data.valid) {
      return t('This Promo code is no longer valid.');
    }

    if (data.amount_off && data.amount_off > 0) {
      return null;
    }
    else if (data.percent_off && data.percent_off > 0) {
      return null;
    }
    else {
      log.error('Unhandled coupon configuration', data);
      return t('This Promo code is not valid.');
    }
  }

  getDisplayPrice(price) {
    var split = ('' + price).split('.')
    if (split.length > 1) {
      var cents = +split[1];
      if (cents === 0) {
        return +split[0];
      }
      else {
        return price.toFixed(2);
      }
    }
    else {
      return +price;
    }
  }

  applyPromoCode() {
    let { t } = this.props;
    let {promo_code, allAvailablePlans, selectedPlanId} = this.state;

    api.Stripe.validateCoupon(promo_code, selectedPlanId)
      .then((res) => {
        log.log('validate coupon res', res);

        let coupon = res.data;
        let msg = this.validateCouponData(coupon);
        if (msg) {
          this.setState({
            validationErr: [msg]
          })
          return;
        }
        else {
          this.setState({
            validationErr: []
          })
        }

        let selectedPlan = _.find(allAvailablePlans, (plan) => +plan.class_id === selectedPlanId)
        let selectedTermCost = +(selectedPlan['term_cost']);
        let isYearlyTerm = _.get(selectedPlan, 'term_length') === UpgradeDialogNew.YEARLY_TERM_SECONDS;
        let termText = isYearlyTerm ? t('/ year') : t('/ month');

        //Then it's valid.
        let couponDeets = null;
        var monthDuration = coupon.duration === 'once' ? 1 : coupon.duration_in_months;
        let termCostCents = selectedTermCost * 100;
        let month_duration = null;
        if(monthDuration){
          month_duration = monthDuration === 1 ? t('1 month') : monthDuration + t(' months')
        }
        if (coupon.amount_off && coupon.amount_off > 0) {

          //FYI - amount_off comes back in cents
          let price = this.getDisplayPrice((selectedTermCost - (coupon.amount_off / 100)));
          price = Math.max(price, 0);

          couponDeets = {
            name: coupon.name,
            price: price,
            monthly_amount: (price === 0 ? t('Free') : filters.getCurrency(this.props.i18n.language, price * 100) + " " + termText),
            month_duration,
            normal_monthly: filters.getCurrency(this.props.i18n.language, termCostCents),
            coupon: coupon
          };
        }
        else if (coupon.percent_off && coupon.percent_off > 0) {

          let price = this.getDisplayPrice((selectedTermCost - (selectedTermCost * (coupon.percent_off / 100))));
          price = Math.max(price, 0);

          couponDeets = {
            name: coupon.name,
            price: price,
            monthly_amount: (price === 0 ? t('Free') : filters.getCurrency(this.props.i18n.language, price * 100) + " " + termText),
            month_duration,
            normal_monthly: filters.getCurrency(this.props.i18n.language, termCostCents),
            coupon: coupon
          }
        }

        this.setState({
          valid_code_deets: couponDeets
        })
      })
      .catch((err) => {
        log.log('error validating coupon', err);

        this.setState({
          validationErr: [t('This Promo code is not valid.')]
        })
      })
  }

  clearCoupon() {
    this.setState({
      valid_code_deets: null,
      promo_code: '',
      validationErr : []
    })
  }

  getCouponControls() {
    let { t } = this.props;
    let {
      valid_code_deets,
      paymentWasSuccessful,
      loading
    } = this.state;

    //I disable the button this way to get around a display issue,
    //where it becomes semi-transparent
    let disableClearButton = (paymentWasSuccessful || loading);

    return (
      <div className="mb-1" style={styles.couponBox}>
        <Button className={'btn btn-dark no-focus'}
                type={'button'}
                style={styles.clearButton}
                onClick={disableClearButton ? _.noop : this.clearCoupon.bind(this)}>
          <i className="icon ion-close"/>
        </Button>
        <div className={'text-center'}>
          {/*This padding is to prevent overlapping text under the close button*/}
          <h4 style={{paddingRight: '20px'}}>
            {valid_code_deets.name} {t("Promo Applied")}
          </h4>
          {valid_code_deets.month_duration &&
            <>
              <h5 className={'green-color'}>
                {valid_code_deets.monthly_amount} {t("for")} {valid_code_deets.month_duration}
              </h5>
              <p className="mb-1">
                {valid_code_deets.normal_monthly}{t("/month after that")}
              </p>
            </>
          }
          {!valid_code_deets.month_duration &&
            <>
              <h5 className={'green-color'}>
                {valid_code_deets.monthly_amount} {t("forever")}
              </h5>
            </>
          }
        </div>
      </div>
    )
  }

  onTimeframeToggleChange(evt) {
    let {
      uiPlans,
      allAvailablePlans,
      carouselKey
    } = this.state;

    let currentSlide = _.get(this.sliderRef, 'innerSlider.state.currentSlide', 0);
    let currentPlan = uiPlans[currentSlide];
    let currentTag = this.getLogoTag(currentPlan, allAvailablePlans);

    this.setState({showMonthlyPlans: !evt.target.checked}, () => {
      let newUiPlans = this.buildUiPlans();
      let carouselStart = _.findIndex(newUiPlans, (p) => {
        return currentTag ?
          this.getLogoTag(p, allAvailablePlans) === currentTag
          : +p.id === +currentPlan.id;
      });
      this.setState({
        uiPlans: newUiPlans,
        carouselStart: Math.max(0, carouselStart),
        carouselKey: (carouselKey || 0) + 1
      });
    })
  }

  getLogoTag(uiPlan, allAvailablePlans){
    let availablePlan = _.find(allAvailablePlans, (p) => +p.class_id === +_.get(uiPlan, 'id'));
    return _.get(availablePlan, 'logo_tag');
  }

  renderPromoCodePanel(){
    let { t } = this.props;
    let {
      promo_code,
      valid_code_deets,
      paymentWasSuccessful,
      loading
    } = this.state;

    return (
      <>
        {!valid_code_deets &&
        <div>
          <label className="form-label fw-bold w-100 text-start dark-color">{t("Promo Code")}</label>
          <div className="form-inline">
            <input className="form-control me-1"
                   style={{'flex': 1}}
                   type={'text'}
                   value={promo_code}
                   disabled={paymentWasSuccessful || loading}
                   placeholder={t("Optional")}
                   onChange={(evt) => this.setState({promo_code: evt.target.value.toUpperCase()})}/>
            <Button disabled={promo_code.length === 0 || (paymentWasSuccessful || loading)}
                    onClick={this.applyPromoCode.bind(this)}
                    type={'button'}
                    className={'btn btn-secondary'}>{t("Apply")}</Button>
          </div>
        </div>
        }
        {valid_code_deets &&
        <div className="position-relative d-block">
          {this.getCouponControls()}
        </div>
        }
      </>
    )
  }

  renderLimitMessage(){
    let {
      limitMessage,
      windowStep
    } = this.state;

    if(!limitMessage){
      return null;
    }

    let hidePanel = windowStep === this.STEPS.CONFIRM_PLAN;
    let hideStyle = {};
    if(hidePanel){
      hideStyle = {
        opacity: 0,
        pointerEvents: 'none'
      }
    }

    return (
      <div className="row" style={hideStyle}>
        <div className="col">
          <div className={'alert alert-warning'}>

            <div className="d-flex">
              <div className="me-2">
                <i className="icon ion-android-warning align-middle"
                   style={{ fontSize: '20px', lineHeight: '30px' }}/>
              </div>
              <div style={{lineHeight: '30px'}}>
                {limitMessage}
              </div>
            </div>

          </div>
        </div>
      </div>
    )
  }

  renderTimeframeToggle(){
    let {
      showMonthlyPlans,
      paymentWasSuccessful,
      windowStep,
      loading
    } = this.state;
    let {
      t
    } = this.props;

    let hidePanel = windowStep === this.STEPS.CONFIRM_PLAN;
    let hideStyle = {};
    if(hidePanel){
      hideStyle = {
        opacity: 0,
        pointerEvents: 'none'
      }
    }
    return (
      <div className="row" style={hideStyle}>
        <div className="col">

          <div className="text-center mt-1 mb-3">
            <div className="d-flex justify-content-center">
              <div className="me-3" style={{lineHeight: '40px'}}>
                {t("Monthly")}
              </div>
              <span className="form-check form-switch form-switch-lg justify-content-end d-flex">
                <input className="form-check-input"
                       disabled={paymentWasSuccessful || loading}
                       type="checkbox"
                       role="switch"
                       onChange={this.onTimeframeToggleChange.bind(this)}
                       checked={!showMonthlyPlans}
                       id="timeframe-checkbox"/>
                <label className="form-check-label" htmlFor={'timeframe-checkbox'} />
              </span>
              <div className="ms-3" style={{lineHeight: '40px'}}>
                {t("Yearly")}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  onEscapeKey(){
    this.closeModal(false);
  }

  render() {
    let { t, i18n } = this.props;
    let {
      loading,
      windowStep
    } = this.state;

    return (
      <div className="modal-content">
        <Elements stripe={this.state.stripePromise} options={{locale: i18n.language}} key={i18n.language}>
          <ElementsConsumer>
            {({stripe, elements}) => {
              return (
                <>
                  <form onSubmit={this.onSubmitButtonClick.bind(this, stripe, elements)}>
                    <div className="modal-header draggable-header modal-header-sticky">
                      <h5 className="modal-title">{t("Subscription Management")}</h5>
                      <button type="button" className="close" onClick={this.closeModal.bind(this, false)}
                              aria-label={t("Close")}>
                        <i className="icon ion-ios-close-empty"/>
                      </button>
                    </div>
                    <div className="modal-body">

                      {windowStep === this.STEPS.SELECT_PLAN &&
                        <div>
                          {this.renderLimitMessage()}
                          {this.renderTimeframeToggle()}
                          <div className="row">
                            <div className="col gradient-carousel-wrapper">
                              {this.renderPlanPanel()}
                            </div>
                          </div>
                        </div>
                      }
                      {windowStep === this.STEPS.CONFIRM_PLAN &&
                      <div>
                        {this.renderLimitMessage()}
                        {this.renderTimeframeToggle()}
                        <div className="row">
                          <div className="col">
                            {this.renderConfirmPanel()}
                          </div>
                        </div>
                      </div>
                      }
                    </div>
                  </form>
                </>
              )
            }}
          </ElementsConsumer>
        </Elements>
      </div>
    )
  }
}

UpgradeDialogNew.UPGRADE_TYPES = {
  WORKSPACE : 'workspace',
  DOCS : 'docs',
  STORAGE : 'storage',
  MAX_V2_SIGNING_LIMIT : 'max_v2_signing_limit',
  MERCHANT_INVOICING : 'merchant_invoicing',
  SIGNING : 'signing',
  SIGNING_V1 : 'signing_v1'
}

const PLAN_CARD_HEIGHT = '50rem';

const styles = {
  couponBox: {
    padding: '10px',
    border: 'dashed 2px grey',
    textAlign: 'center',
  },
  clearButton: {
    position: 'absolute',
    top: '-15px',
    right: '-8px',
    border: '10px solid',
    zIndex: '100',
    borderRadius: '50%'
  }
}

const mapStateToProps = (state) => {
  return {
    accountInfo: state.shared.accountInfo,
    accountClassInfo: state.shared.accountClassInfo,
    stripeAvailables: state.shared.stripeAvailables,
    workspaces: state.shared.workspaces,
    contacts: state.shared.contacts,
    userHandle : state.account.userHandle,
    app : {...state.app},
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateAccountInfo : () => dispatch(sharedActions.updateAccountInfo()),
    updateStripeAvailables : () => dispatch(sharedActions.updateStripeAvailables()),
    updateStripeData : () => dispatch(sharedActions.updateStripeData()),
    updateLogo : () => dispatch(sharedActions.updateLogo()),
    updateUserHandle : () => dispatch(accountActions.updateUserHandle()),
    cleanup : () => dispatch(appActions.cleanup()),
    ...modalActions.mapToDispatch(dispatch)
  };
};

UpgradeDialogNew.propTypes = {
  close : PropTypes.func.isRequired,
  onRef : PropTypes.func,
  modalProps : PropTypes.object.isRequired
}

export default withVFTranslation()(withVfRouting(connect(mapStateToProps, mapDispatchToProps)(UpgradeDialogNew)));
